import { CITY } from '@city'
import { LegalLayout } from '../components/LegalLayout'
import { AnalyticsCookiePolicy } from './cookiePolicy/AnalyticsCookiePolicy'
import { CookieFreePolicy } from './cookiePolicy/CookieFreePolicy'

/**
 * Cookie policy of the city the build is for: the analytics cookies and the
 * consent controls where the site runs web analytics, a no-cookies notice
 * where it does not (`CITY.webAnalytics`).
 */
export function CookiePolicyPage() {
  return (
    <LegalLayout current="cookie">
      <h1>Cookie Policy</h1>
      {CITY.webAnalytics ? <AnalyticsCookiePolicy /> : <CookieFreePolicy />}
    </LegalLayout>
  )
}
